/* eslint-disable */
import {
  DomainEntityId,
  DomainEntityReflection,
  EntityReflections,
  EnumLike,
  EnumReflection,
  RawAliasReflection,
  SchemaOfObject,
  SchemaReflection,
} from '@salsita-ai/platform-project-sdk/domain'

export const modelVersion = 1

export type ThicknessesTypes = 'Standard' | 'Thick' | 'Rolled'
export const ThicknessesTypes: EnumLike<ThicknessesTypes> = new EnumReflection('ThicknessesTypes', {
  enum: ['Standard', 'Thick', 'Rolled'],
}) as EnumLike<ThicknessesTypes>

export type BaseTypes = 'Pedestal' | 'Metal' | 'FourLeg'
export const BaseTypes: EnumLike<BaseTypes> = new EnumReflection('BaseTypes', {
  enum: ['Pedestal', 'Metal', 'FourLeg'],
}) as EnumLike<BaseTypes>

export type WoodSpecies = 'Hickory' | 'Ash' | 'Maple' | 'Walnut' | 'QuarterSawnWhiteOak'
export const WoodSpecies: EnumLike<WoodSpecies> = new EnumReflection('WoodSpecies', {
  enum: ['Hickory', 'Ash', 'Maple', 'Walnut', 'QuarterSawnWhiteOak'],
}) as EnumLike<WoodSpecies>

export type DistressLevels = 'Clean' | 'Minimal' | 'Light' | 'Medium' | 'Heavy' | 'RoughSawn'
export const DistressLevels: EnumLike<DistressLevels> = new EnumReflection('DistressLevels', {
  enum: ['Clean', 'Minimal', 'Light', 'Medium', 'Heavy', 'RoughSawn'],
}) as EnumLike<DistressLevels>

export type EdgeStyles = 'Clean' | 'NaturalWavy' | 'Tumbled' | 'Dupont' | 'Beveled'
export const EdgeStyles: EnumLike<EdgeStyles> = new EnumReflection('EdgeStyles', {
  enum: ['Clean', 'NaturalWavy', 'Tumbled', 'Dupont', 'Beveled'],
}) as EnumLike<EdgeStyles>

export type Finishes =
  | 'BlackTone'
  | 'EbonyTone'
  | 'Gray'
  | 'DarkBrownTone'
  | 'MediumBrownTone'
  | 'LightBrownTone'
  | 'NaturalTone'
  | 'Earthtone'
  | 'Taupe'
  | 'Custom'
export const Finishes: EnumLike<Finishes> = new EnumReflection('Finishes', {
  enum: [
    'BlackTone',
    'EbonyTone',
    'Gray',
    'DarkBrownTone',
    'MediumBrownTone',
    'LightBrownTone',
    'NaturalTone',
    'Earthtone',
    'Taupe',
    'Custom',
  ],
}) as EnumLike<Finishes>

export type SheenTypes = 'Flat' | 'Satin'
export const SheenTypes: EnumLike<SheenTypes> = new EnumReflection('SheenTypes', {
  enum: ['Flat', 'Satin'],
}) as EnumLike<SheenTypes>

export type LeafTypes =
  | 'NoLeaf'
  | 'Standard'
  | 'Medium'
  | 'Large'
  | 'Perimeter'
  | 'StandardDropIn'
  | 'MediumDropIn'
  | 'LargeDropIn'
  | 'CustomLeaf'
export const LeafTypes: EnumLike<LeafTypes> = new EnumReflection('LeafTypes', {
  enum: [
    'NoLeaf',
    'Standard',
    'Medium',
    'Large',
    'Perimeter',
    'StandardDropIn',
    'MediumDropIn',
    'LargeDropIn',
    'CustomLeaf',
  ],
}) as EnumLike<LeafTypes>

export type SeatingTypes = 'NoSeating' | 'Benches' | 'Chairs' | 'ChairsAndBenches'
export const SeatingTypes: EnumLike<SeatingTypes> = new EnumReflection('SeatingTypes', {
  enum: ['NoSeating', 'Benches', 'Chairs', 'ChairsAndBenches'],
}) as EnumLike<SeatingTypes>

export type CrossbraceTypes = 'StandardCrossbrace' | 'NotchedCrossbrace'
export const CrossbraceTypes: EnumLike<CrossbraceTypes> = new EnumReflection('CrossbraceTypes', {
  enum: ['StandardCrossbrace', 'NotchedCrossbrace'],
}) as EnumLike<CrossbraceTypes>

interface TableShape {
  readonly topId: Top['id']
  readonly baseStyleId: Base['id']
  readonly benchId: Bench['id']
  readonly baseType: BaseTypes
  readonly woodSpecies: WoodSpecies
  readonly sheen: SheenTypes
  readonly seatingType: SeatingTypes
  readonly seatingAmount: number
}
const TableShape = new SchemaReflection<Table, SchemaOfObject<TableShape>>('TableShape', {
  type: 'object',
  properties: {
    topId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
    baseStyleId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
    benchId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
    baseType: BaseTypes._meta.schema,
    woodSpecies: WoodSpecies._meta.schema,
    sheen: SheenTypes._meta.schema,
    seatingType: SeatingTypes._meta.schema,
    seatingAmount: {
      type: 'number',
    },
  },
  additionalProperties: false,
  required: ['topId', 'baseStyleId', 'benchId', 'baseType', 'woodSpecies', 'sheen', 'seatingType', 'seatingAmount'],
})

interface TopShape {
  readonly apronId: Apron['id']
  readonly thicknessType: ThicknessesTypes
  readonly edgeStyle: EdgeStyles
  readonly distressLevel: DistressLevels
  readonly finish: Finishes
  readonly withGrooves: boolean
  readonly withCornerRadius: boolean
  readonly leafType: LeafTypes
  readonly leafAmount: number
  readonly thickness: number
}
const TopShape = new SchemaReflection<Top, SchemaOfObject<TopShape>>('TopShape', {
  type: 'object',
  properties: {
    apronId: {
      type: 'string',
      pattern: '^[A-Z]\\w*-\\d+$',
    },
    thicknessType: ThicknessesTypes._meta.schema,
    edgeStyle: EdgeStyles._meta.schema,
    distressLevel: DistressLevels._meta.schema,
    finish: Finishes._meta.schema,
    withGrooves: {
      type: 'boolean',
    },
    withCornerRadius: {
      type: 'boolean',
    },
    leafType: LeafTypes._meta.schema,
    leafAmount: {
      type: 'number',
    },
    thickness: {
      type: 'number',
    },
  },
  additionalProperties: false,
  required: [
    'apronId',
    'thicknessType',
    'edgeStyle',
    'distressLevel',
    'finish',
    'withGrooves',
    'withCornerRadius',
    'leafType',
    'leafAmount',
    'thickness',
  ],
})

interface BaseShape {
  readonly hasCrossbrace: boolean
  readonly finish: Finishes
}
const BaseShape = new SchemaReflection<Base, SchemaOfObject<BaseShape>>('BaseShape', {
  type: 'object',
  properties: {
    hasCrossbrace: {
      type: 'boolean',
    },
    finish: Finishes._meta.schema,
  },
  additionalProperties: false,
  required: ['hasCrossbrace', 'finish'],
})

interface TopWithWidthAndLengthShape {
  readonly width: number
  readonly length: number
}
const TopWithWidthAndLengthShape = new SchemaReflection<
  TopWithWidthAndLength,
  SchemaOfObject<TopWithWidthAndLengthShape>
>('TopWithWidthAndLengthShape', {
  type: 'object',
  properties: {
    width: {
      type: 'number',
    },
    length: {
      type: 'number',
    },
  },
  additionalProperties: false,
  required: ['width', 'length'],
})

interface TopWithSideShape {
  readonly side: number
}
const TopWithSideShape = new SchemaReflection<TopWithSide, SchemaOfObject<TopWithSideShape>>('TopWithSideShape', {
  type: 'object',
  properties: {
    side: {
      type: 'number',
    },
  },
  additionalProperties: false,
  required: ['side'],
})

interface TopWithDiameterShape {
  readonly diameter: number
}
const TopWithDiameterShape = new SchemaReflection<TopWithDiameter, SchemaOfObject<TopWithDiameterShape>>(
  'TopWithDiameterShape',
  {
    type: 'object',
    properties: {
      diameter: {
        type: 'number',
      },
    },
    additionalProperties: false,
    required: ['diameter'],
  }
)

export interface Table extends TableShape {
  readonly id: DomainEntityId<'Table'>
  readonly type: 'Table'
}
export const Table: DomainEntityReflection<Table> = new DomainEntityReflection<Table>('Table', [
  TableShape._meta.schema,
])

export interface RectangleTop extends TopShape, TopWithWidthAndLengthShape {
  readonly id: DomainEntityId<'RectangleTop'>
  readonly type: 'RectangleTop'
}
export const RectangleTop: DomainEntityReflection<RectangleTop> = new DomainEntityReflection<RectangleTop>(
  'RectangleTop',
  [TopShape._meta.schema, TopWithWidthAndLengthShape._meta.schema]
)

export interface SquareTop extends TopShape, TopWithSideShape {
  readonly id: DomainEntityId<'SquareTop'>
  readonly type: 'SquareTop'
}
export const SquareTop: DomainEntityReflection<SquareTop> = new DomainEntityReflection<SquareTop>('SquareTop', [
  TopShape._meta.schema,
  TopWithSideShape._meta.schema,
])

export interface RoundTop extends TopShape, TopWithDiameterShape {
  readonly id: DomainEntityId<'RoundTop'>
  readonly type: 'RoundTop'
}
export const RoundTop: DomainEntityReflection<RoundTop> = new DomainEntityReflection<RoundTop>('RoundTop', [
  TopShape._meta.schema,
  TopWithDiameterShape._meta.schema,
])

export interface EllipticalOvalTop extends TopShape, TopWithWidthAndLengthShape {
  readonly id: DomainEntityId<'EllipticalOvalTop'>
  readonly type: 'EllipticalOvalTop'
}
export const EllipticalOvalTop: DomainEntityReflection<EllipticalOvalTop> =
  new DomainEntityReflection<EllipticalOvalTop>('EllipticalOvalTop', [
    TopShape._meta.schema,
    TopWithWidthAndLengthShape._meta.schema,
  ])

export interface RacetrackOvalTop extends TopShape, TopWithWidthAndLengthShape {
  readonly id: DomainEntityId<'RacetrackOvalTop'>
  readonly type: 'RacetrackOvalTop'
}
export const RacetrackOvalTop: DomainEntityReflection<RacetrackOvalTop> = new DomainEntityReflection<RacetrackOvalTop>(
  'RacetrackOvalTop',
  [TopShape._meta.schema, TopWithWidthAndLengthShape._meta.schema]
)

export interface BoatShapeTop extends TopShape, TopWithWidthAndLengthShape {
  readonly id: DomainEntityId<'BoatShapeTop'>
  readonly type: 'BoatShapeTop'
}
export const BoatShapeTop: DomainEntityReflection<BoatShapeTop> = new DomainEntityReflection<BoatShapeTop>(
  'BoatShapeTop',
  [TopShape._meta.schema, TopWithWidthAndLengthShape._meta.schema]
)

export interface AnchorBase extends BaseShape {
  readonly id: DomainEntityId<'AnchorBase'>
  readonly type: 'AnchorBase'
}
export const AnchorBase: DomainEntityReflection<AnchorBase> = new DomainEntityReflection<AnchorBase>('AnchorBase', [
  BaseShape._meta.schema,
])

export interface AnchorSingleFeetBase extends BaseShape {
  readonly id: DomainEntityId<'AnchorSingleFeetBase'>
  readonly type: 'AnchorSingleFeetBase'
}
export const AnchorSingleFeetBase: DomainEntityReflection<AnchorSingleFeetBase> =
  new DomainEntityReflection<AnchorSingleFeetBase>('AnchorSingleFeetBase', [BaseShape._meta.schema])

export interface AnchorSinglePlatformBase extends BaseShape {
  readonly id: DomainEntityId<'AnchorSinglePlatformBase'>
  readonly type: 'AnchorSinglePlatformBase'
}
export const AnchorSinglePlatformBase: DomainEntityReflection<AnchorSinglePlatformBase> =
  new DomainEntityReflection<AnchorSinglePlatformBase>('AnchorSinglePlatformBase', [BaseShape._meta.schema])

export interface BellhouseBase extends BaseShape {
  readonly id: DomainEntityId<'BellhouseBase'>
  readonly type: 'BellhouseBase'
}
export const BellhouseBase: DomainEntityReflection<BellhouseBase> = new DomainEntityReflection<BellhouseBase>(
  'BellhouseBase',
  [BaseShape._meta.schema]
)

export interface BellhouseSingleFeetBase extends BaseShape {
  readonly id: DomainEntityId<'BellhouseSingleFeetBase'>
  readonly type: 'BellhouseSingleFeetBase'
}
export const BellhouseSingleFeetBase: DomainEntityReflection<BellhouseSingleFeetBase> =
  new DomainEntityReflection<BellhouseSingleFeetBase>('BellhouseSingleFeetBase', [BaseShape._meta.schema])

export interface BellhouseSinglePlatformBase extends BaseShape {
  readonly id: DomainEntityId<'BellhouseSinglePlatformBase'>
  readonly type: 'BellhouseSinglePlatformBase'
}
export const BellhouseSinglePlatformBase: DomainEntityReflection<BellhouseSinglePlatformBase> =
  new DomainEntityReflection<BellhouseSinglePlatformBase>('BellhouseSinglePlatformBase', [BaseShape._meta.schema])

export interface BellyStretchedBase extends BaseShape {
  readonly id: DomainEntityId<'BellyStretchedBase'>
  readonly type: 'BellyStretchedBase'
}
export const BellyStretchedBase: DomainEntityReflection<BellyStretchedBase> =
  new DomainEntityReflection<BellyStretchedBase>('BellyStretchedBase', [BaseShape._meta.schema])

export interface BrewerBase extends BaseShape {
  readonly id: DomainEntityId<'BrewerBase'>
  readonly type: 'BrewerBase'
}
export const BrewerBase: DomainEntityReflection<BrewerBase> = new DomainEntityReflection<BrewerBase>('BrewerBase', [
  BaseShape._meta.schema,
])

export interface BrewerSingleBase extends BaseShape {
  readonly id: DomainEntityId<'BrewerSingleBase'>
  readonly type: 'BrewerSingleBase'
}
export const BrewerSingleBase: DomainEntityReflection<BrewerSingleBase> = new DomainEntityReflection<BrewerSingleBase>(
  'BrewerSingleBase',
  [BaseShape._meta.schema]
)

export interface CaseyBase extends BaseShape {
  readonly id: DomainEntityId<'CaseyBase'>
  readonly type: 'CaseyBase'
}
export const CaseyBase: DomainEntityReflection<CaseyBase> = new DomainEntityReflection<CaseyBase>('CaseyBase', [
  BaseShape._meta.schema,
])

export interface CraftsmanBase extends BaseShape {
  readonly id: DomainEntityId<'CraftsmanBase'>
  readonly type: 'CraftsmanBase'
}
export const CraftsmanBase: DomainEntityReflection<CraftsmanBase> = new DomainEntityReflection<CraftsmanBase>(
  'CraftsmanBase',
  [BaseShape._meta.schema]
)

export interface CraftsmanSingleBase extends BaseShape {
  readonly id: DomainEntityId<'CraftsmanSingleBase'>
  readonly type: 'CraftsmanSingleBase'
}
export const CraftsmanSingleBase: DomainEntityReflection<CraftsmanSingleBase> =
  new DomainEntityReflection<CraftsmanSingleBase>('CraftsmanSingleBase', [BaseShape._meta.schema])

export interface CrescentBase extends BaseShape {
  readonly id: DomainEntityId<'CrescentBase'>
  readonly type: 'CrescentBase'
}
export const CrescentBase: DomainEntityReflection<CrescentBase> = new DomainEntityReflection<CrescentBase>(
  'CrescentBase',
  [BaseShape._meta.schema]
)

export interface CrescentSingleBase extends BaseShape {
  readonly id: DomainEntityId<'CrescentSingleBase'>
  readonly type: 'CrescentSingleBase'
}
export const CrescentSingleBase: DomainEntityReflection<CrescentSingleBase> =
  new DomainEntityReflection<CrescentSingleBase>('CrescentSingleBase', [BaseShape._meta.schema])

export interface DanaBase extends BaseShape {
  readonly id: DomainEntityId<'DanaBase'>
  readonly type: 'DanaBase'
}
export const DanaBase: DomainEntityReflection<DanaBase> = new DomainEntityReflection<DanaBase>('DanaBase', [
  BaseShape._meta.schema,
])

export interface DanaSingleBase extends BaseShape {
  readonly id: DomainEntityId<'DanaSingleBase'>
  readonly type: 'DanaSingleBase'
}
export const DanaSingleBase: DomainEntityReflection<DanaSingleBase> = new DomainEntityReflection<DanaSingleBase>(
  'DanaSingleBase',
  [BaseShape._meta.schema]
)

export interface FranklinBase extends BaseShape {
  readonly id: DomainEntityId<'FranklinBase'>
  readonly type: 'FranklinBase'
}
export const FranklinBase: DomainEntityReflection<FranklinBase> = new DomainEntityReflection<FranklinBase>(
  'FranklinBase',
  [BaseShape._meta.schema]
)

export interface FranklinSingleFeetBase extends BaseShape {
  readonly id: DomainEntityId<'FranklinSingleFeetBase'>
  readonly type: 'FranklinSingleFeetBase'
}
export const FranklinSingleFeetBase: DomainEntityReflection<FranklinSingleFeetBase> =
  new DomainEntityReflection<FranklinSingleFeetBase>('FranklinSingleFeetBase', [BaseShape._meta.schema])

export interface FranklinSinglePlatformBase extends BaseShape {
  readonly id: DomainEntityId<'FranklinSinglePlatformBase'>
  readonly type: 'FranklinSinglePlatformBase'
}
export const FranklinSinglePlatformBase: DomainEntityReflection<FranklinSinglePlatformBase> =
  new DomainEntityReflection<FranklinSinglePlatformBase>('FranklinSinglePlatformBase', [BaseShape._meta.schema])

export interface MantisBase extends BaseShape {
  readonly id: DomainEntityId<'MantisBase'>
  readonly type: 'MantisBase'
}
export const MantisBase: DomainEntityReflection<MantisBase> = new DomainEntityReflection<MantisBase>('MantisBase', [
  BaseShape._meta.schema,
])

export interface MarksBase extends BaseShape {
  readonly id: DomainEntityId<'MarksBase'>
  readonly type: 'MarksBase'
}
export const MarksBase: DomainEntityReflection<MarksBase> = new DomainEntityReflection<MarksBase>('MarksBase', [
  BaseShape._meta.schema,
])

export interface MeredithBase extends BaseShape {
  readonly id: DomainEntityId<'MeredithBase'>
  readonly type: 'MeredithBase'
}
export const MeredithBase: DomainEntityReflection<MeredithBase> = new DomainEntityReflection<MeredithBase>(
  'MeredithBase',
  [BaseShape._meta.schema]
)

export interface MeredithSingleFeetBase extends BaseShape {
  readonly id: DomainEntityId<'MeredithSingleFeetBase'>
  readonly type: 'MeredithSingleFeetBase'
}
export const MeredithSingleFeetBase: DomainEntityReflection<MeredithSingleFeetBase> =
  new DomainEntityReflection<MeredithSingleFeetBase>('MeredithSingleFeetBase', [BaseShape._meta.schema])

export interface MeredithSinglePlatformBase extends BaseShape {
  readonly id: DomainEntityId<'MeredithSinglePlatformBase'>
  readonly type: 'MeredithSinglePlatformBase'
}
export const MeredithSinglePlatformBase: DomainEntityReflection<MeredithSinglePlatformBase> =
  new DomainEntityReflection<MeredithSinglePlatformBase>('MeredithSinglePlatformBase', [BaseShape._meta.schema])

export interface OswaldBase extends BaseShape {
  readonly id: DomainEntityId<'OswaldBase'>
  readonly type: 'OswaldBase'
}
export const OswaldBase: DomainEntityReflection<OswaldBase> = new DomainEntityReflection<OswaldBase>('OswaldBase', [
  BaseShape._meta.schema,
])

export interface OswaldSingleBase extends BaseShape {
  readonly id: DomainEntityId<'OswaldSingleBase'>
  readonly type: 'OswaldSingleBase'
}
export const OswaldSingleBase: DomainEntityReflection<OswaldSingleBase> = new DomainEntityReflection<OswaldSingleBase>(
  'OswaldSingleBase',
  [BaseShape._meta.schema]
)

export interface PeruStretchedBase extends BaseShape {
  readonly id: DomainEntityId<'PeruStretchedBase'>
  readonly type: 'PeruStretchedBase'
}
export const PeruStretchedBase: DomainEntityReflection<PeruStretchedBase> =
  new DomainEntityReflection<PeruStretchedBase>('PeruStretchedBase', [BaseShape._meta.schema])

export interface RishBase extends BaseShape {
  readonly id: DomainEntityId<'RishBase'>
  readonly type: 'RishBase'
}
export const RishBase: DomainEntityReflection<RishBase> = new DomainEntityReflection<RishBase>('RishBase', [
  BaseShape._meta.schema,
])

export interface RishSingleBase extends BaseShape {
  readonly id: DomainEntityId<'RishSingleBase'>
  readonly type: 'RishSingleBase'
}
export const RishSingleBase: DomainEntityReflection<RishSingleBase> = new DomainEntityReflection<RishSingleBase>(
  'RishSingleBase',
  [BaseShape._meta.schema]
)

export interface RogersBase extends BaseShape {
  readonly id: DomainEntityId<'RogersBase'>
  readonly type: 'RogersBase'
}
export const RogersBase: DomainEntityReflection<RogersBase> = new DomainEntityReflection<RogersBase>('RogersBase', [
  BaseShape._meta.schema,
])

export interface RogersSinglePlatformBase extends BaseShape {
  readonly id: DomainEntityId<'RogersSinglePlatformBase'>
  readonly type: 'RogersSinglePlatformBase'
}
export const RogersSinglePlatformBase: DomainEntityReflection<RogersSinglePlatformBase> =
  new DomainEntityReflection<RogersSinglePlatformBase>('RogersSinglePlatformBase', [BaseShape._meta.schema])

export interface TamaraBase extends BaseShape {
  readonly id: DomainEntityId<'TamaraBase'>
  readonly type: 'TamaraBase'
}
export const TamaraBase: DomainEntityReflection<TamaraBase> = new DomainEntityReflection<TamaraBase>('TamaraBase', [
  BaseShape._meta.schema,
])

export interface TamaraSingleBase extends BaseShape {
  readonly id: DomainEntityId<'TamaraSingleBase'>
  readonly type: 'TamaraSingleBase'
}
export const TamaraSingleBase: DomainEntityReflection<TamaraSingleBase> = new DomainEntityReflection<TamaraSingleBase>(
  'TamaraSingleBase',
  [BaseShape._meta.schema]
)

export interface TuscanBase extends BaseShape {
  readonly id: DomainEntityId<'TuscanBase'>
  readonly type: 'TuscanBase'
}
export const TuscanBase: DomainEntityReflection<TuscanBase> = new DomainEntityReflection<TuscanBase>('TuscanBase', [
  BaseShape._meta.schema,
])

export interface TuscanSingleFeetBase extends BaseShape {
  readonly id: DomainEntityId<'TuscanSingleFeetBase'>
  readonly type: 'TuscanSingleFeetBase'
}
export const TuscanSingleFeetBase: DomainEntityReflection<TuscanSingleFeetBase> =
  new DomainEntityReflection<TuscanSingleFeetBase>('TuscanSingleFeetBase', [BaseShape._meta.schema])

export interface TuscanSinglePlatformBase extends BaseShape {
  readonly id: DomainEntityId<'TuscanSinglePlatformBase'>
  readonly type: 'TuscanSinglePlatformBase'
}
export const TuscanSinglePlatformBase: DomainEntityReflection<TuscanSinglePlatformBase> =
  new DomainEntityReflection<TuscanSinglePlatformBase>('TuscanSinglePlatformBase', [BaseShape._meta.schema])

export interface WaldenBase extends BaseShape {
  readonly id: DomainEntityId<'WaldenBase'>
  readonly type: 'WaldenBase'
}
export const WaldenBase: DomainEntityReflection<WaldenBase> = new DomainEntityReflection<WaldenBase>('WaldenBase', [
  BaseShape._meta.schema,
])

export interface WaldenSingleBase extends BaseShape {
  readonly id: DomainEntityId<'WaldenSingleBase'>
  readonly type: 'WaldenSingleBase'
}
export const WaldenSingleBase: DomainEntityReflection<WaldenSingleBase> = new DomainEntityReflection<WaldenSingleBase>(
  'WaldenSingleBase',
  [BaseShape._meta.schema]
)

export interface AnglePictureFrameBase extends BaseShape {
  readonly id: DomainEntityId<'AnglePictureFrameBase'>
  readonly type: 'AnglePictureFrameBase'
}
export const AnglePictureFrameBase: DomainEntityReflection<AnglePictureFrameBase> =
  new DomainEntityReflection<AnglePictureFrameBase>('AnglePictureFrameBase', [BaseShape._meta.schema])

export interface XBase extends BaseShape {
  readonly id: DomainEntityId<'XBase'>
  readonly type: 'XBase'
}
export const XBase: DomainEntityReflection<XBase> = new DomainEntityReflection<XBase>('XBase', [BaseShape._meta.schema])

export interface XSingleBase extends BaseShape {
  readonly id: DomainEntityId<'XSingleBase'>
  readonly type: 'XSingleBase'
}
export const XSingleBase: DomainEntityReflection<XSingleBase> = new DomainEntityReflection<XSingleBase>('XSingleBase', [
  BaseShape._meta.schema,
])

export interface AnglePictureFrameSingleBase extends BaseShape {
  readonly id: DomainEntityId<'AnglePictureFrameSingleBase'>
  readonly type: 'AnglePictureFrameSingleBase'
}
export const AnglePictureFrameSingleBase: DomainEntityReflection<AnglePictureFrameSingleBase> =
  new DomainEntityReflection<AnglePictureFrameSingleBase>('AnglePictureFrameSingleBase', [BaseShape._meta.schema])

export interface AnglePictureFrameCTCBase extends BaseShape {
  readonly id: DomainEntityId<'AnglePictureFrameCTCBase'>
  readonly type: 'AnglePictureFrameCTCBase'
}
export const AnglePictureFrameCTCBase: DomainEntityReflection<AnglePictureFrameCTCBase> =
  new DomainEntityReflection<AnglePictureFrameCTCBase>('AnglePictureFrameCTCBase', [BaseShape._meta.schema])

export interface ArchBase extends BaseShape {
  readonly id: DomainEntityId<'ArchBase'>
  readonly type: 'ArchBase'
}
export const ArchBase: DomainEntityReflection<ArchBase> = new DomainEntityReflection<ArchBase>('ArchBase', [
  BaseShape._meta.schema,
])

export interface ArchSingleBase extends BaseShape {
  readonly id: DomainEntityId<'ArchSingleBase'>
  readonly type: 'ArchSingleBase'
}
export const ArchSingleBase: DomainEntityReflection<ArchSingleBase> = new DomainEntityReflection<ArchSingleBase>(
  'ArchSingleBase',
  [BaseShape._meta.schema]
)

export interface BoxFrameBase extends BaseShape {
  readonly id: DomainEntityId<'BoxFrameBase'>
  readonly type: 'BoxFrameBase'
}
export const BoxFrameBase: DomainEntityReflection<BoxFrameBase> = new DomainEntityReflection<BoxFrameBase>(
  'BoxFrameBase',
  [BaseShape._meta.schema]
)

export interface ConnectedXBase extends BaseShape {
  readonly id: DomainEntityId<'ConnectedXBase'>
  readonly type: 'ConnectedXBase'
}
export const ConnectedXBase: DomainEntityReflection<ConnectedXBase> = new DomainEntityReflection<ConnectedXBase>(
  'ConnectedXBase',
  [BaseShape._meta.schema]
)

export interface SlimConnectedXBase extends BaseShape {
  readonly id: DomainEntityId<'SlimConnectedXBase'>
  readonly type: 'SlimConnectedXBase'
}
export const SlimConnectedXBase: DomainEntityReflection<SlimConnectedXBase> =
  new DomainEntityReflection<SlimConnectedXBase>('SlimConnectedXBase', [BaseShape._meta.schema])

export interface SlimConnectedXSingleBase extends BaseShape {
  readonly id: DomainEntityId<'SlimConnectedXSingleBase'>
  readonly type: 'SlimConnectedXSingleBase'
}
export const SlimConnectedXSingleBase: DomainEntityReflection<SlimConnectedXSingleBase> =
  new DomainEntityReflection<SlimConnectedXSingleBase>('SlimConnectedXSingleBase', [BaseShape._meta.schema])

export interface ReflectionBase extends BaseShape {
  readonly id: DomainEntityId<'ReflectionBase'>
  readonly type: 'ReflectionBase'
}
export const ReflectionBase: DomainEntityReflection<ReflectionBase> = new DomainEntityReflection<ReflectionBase>(
  'ReflectionBase',
  [BaseShape._meta.schema]
)

export interface ReflectionCTCBase extends BaseShape {
  readonly id: DomainEntityId<'ReflectionCTCBase'>
  readonly type: 'ReflectionCTCBase'
}
export const ReflectionCTCBase: DomainEntityReflection<ReflectionCTCBase> =
  new DomainEntityReflection<ReflectionCTCBase>('ReflectionCTCBase', [BaseShape._meta.schema])

export interface SinglePostBase extends BaseShape {
  readonly id: DomainEntityId<'SinglePostBase'>
  readonly type: 'SinglePostBase'
}
export const SinglePostBase: DomainEntityReflection<SinglePostBase> = new DomainEntityReflection<SinglePostBase>(
  'SinglePostBase',
  [BaseShape._meta.schema]
)

export interface SinglePostSingleBase extends BaseShape {
  readonly id: DomainEntityId<'SinglePostSingleBase'>
  readonly type: 'SinglePostSingleBase'
}
export const SinglePostSingleBase: DomainEntityReflection<SinglePostSingleBase> =
  new DomainEntityReflection<SinglePostSingleBase>('SinglePostSingleBase', [BaseShape._meta.schema])

export interface XMetalBase extends BaseShape {
  readonly id: DomainEntityId<'XMetalBase'>
  readonly type: 'XMetalBase'
}
export const XMetalBase: DomainEntityReflection<XMetalBase> = new DomainEntityReflection<XMetalBase>('XMetalBase', [
  BaseShape._meta.schema,
])

export interface XMetalSingleBase extends BaseShape {
  readonly id: DomainEntityId<'XMetalSingleBase'>
  readonly type: 'XMetalSingleBase'
}
export const XMetalSingleBase: DomainEntityReflection<XMetalSingleBase> = new DomainEntityReflection<XMetalSingleBase>(
  'XMetalSingleBase',
  [BaseShape._meta.schema]
)

export interface IvyBase extends BaseShape {
  readonly id: DomainEntityId<'IvyBase'>
  readonly type: 'IvyBase'
}
export const IvyBase: DomainEntityReflection<IvyBase> = new DomainEntityReflection<IvyBase>('IvyBase', [
  BaseShape._meta.schema,
])

export interface DremorTurnedBase extends BaseShape {
  readonly id: DomainEntityId<'DremorTurnedBase'>
  readonly type: 'DremorTurnedBase'
}
export const DremorTurnedBase: DomainEntityReflection<DremorTurnedBase> = new DomainEntityReflection<DremorTurnedBase>(
  'DremorTurnedBase',
  [BaseShape._meta.schema]
)

export interface HerricksonTurnedBase extends BaseShape {
  readonly id: DomainEntityId<'HerricksonTurnedBase'>
  readonly type: 'HerricksonTurnedBase'
}
export const HerricksonTurnedBase: DomainEntityReflection<HerricksonTurnedBase> =
  new DomainEntityReflection<HerricksonTurnedBase>('HerricksonTurnedBase', [BaseShape._meta.schema])

export interface MidModernTaperBase extends BaseShape {
  readonly id: DomainEntityId<'MidModernTaperBase'>
  readonly type: 'MidModernTaperBase'
}
export const MidModernTaperBase: DomainEntityReflection<MidModernTaperBase> =
  new DomainEntityReflection<MidModernTaperBase>('MidModernTaperBase', [BaseShape._meta.schema])

export interface NarrowEnglishTurnedBase extends BaseShape {
  readonly id: DomainEntityId<'NarrowEnglishTurnedBase'>
  readonly type: 'NarrowEnglishTurnedBase'
}
export const NarrowEnglishTurnedBase: DomainEntityReflection<NarrowEnglishTurnedBase> =
  new DomainEntityReflection<NarrowEnglishTurnedBase>('NarrowEnglishTurnedBase', [BaseShape._meta.schema])

export interface OldEnglishTurnedBase extends BaseShape {
  readonly id: DomainEntityId<'OldEnglishTurnedBase'>
  readonly type: 'OldEnglishTurnedBase'
}
export const OldEnglishTurnedBase: DomainEntityReflection<OldEnglishTurnedBase> =
  new DomainEntityReflection<OldEnglishTurnedBase>('OldEnglishTurnedBase', [BaseShape._meta.schema])

export interface SlagleTurnedBase extends BaseShape {
  readonly id: DomainEntityId<'SlagleTurnedBase'>
  readonly type: 'SlagleTurnedBase'
}
export const SlagleTurnedBase: DomainEntityReflection<SlagleTurnedBase> = new DomainEntityReflection<SlagleTurnedBase>(
  'SlagleTurnedBase',
  [BaseShape._meta.schema]
)

export interface TraditionalBase extends BaseShape {
  readonly id: DomainEntityId<'TraditionalBase'>
  readonly type: 'TraditionalBase'
}
export const TraditionalBase: DomainEntityReflection<TraditionalBase> = new DomainEntityReflection<TraditionalBase>(
  'TraditionalBase',
  [BaseShape._meta.schema]
)

export interface TraditionalFlushBase extends BaseShape {
  readonly id: DomainEntityId<'TraditionalFlushBase'>
  readonly type: 'TraditionalFlushBase'
}
export const TraditionalFlushBase: DomainEntityReflection<TraditionalFlushBase> =
  new DomainEntityReflection<TraditionalFlushBase>('TraditionalFlushBase', [BaseShape._meta.schema])

export interface ReededBase extends BaseShape {
  readonly id: DomainEntityId<'ReededBase'>
  readonly type: 'ReededBase'
}
export const ReededBase: DomainEntityReflection<ReededBase> = new DomainEntityReflection<ReededBase>('ReededBase', [
  BaseShape._meta.schema,
])

export interface HershBase extends BaseShape {
  readonly id: DomainEntityId<'HershBase'>
  readonly type: 'HershBase'
}
export const HershBase: DomainEntityReflection<HershBase> = new DomainEntityReflection<HershBase>('HershBase', [
  BaseShape._meta.schema,
])

export interface TriflectionBase extends BaseShape {
  readonly id: DomainEntityId<'TriflectionBase'>
  readonly type: 'TriflectionBase'
}
export const TriflectionBase: DomainEntityReflection<TriflectionBase> = new DomainEntityReflection<TriflectionBase>(
  'TriflectionBase',
  [BaseShape._meta.schema]
)

export interface ApronBasic {
  readonly id: DomainEntityId<'ApronBasic'>
  readonly type: 'ApronBasic'
}
export const ApronBasic: DomainEntityReflection<ApronBasic> = new DomainEntityReflection<ApronBasic>('ApronBasic', [])

export interface ApronNone {
  readonly id: DomainEntityId<'ApronNone'>
  readonly type: 'ApronNone'
}
export const ApronNone: DomainEntityReflection<ApronNone> = new DomainEntityReflection<ApronNone>('ApronNone', [])

export interface BenchBasic {
  readonly id: DomainEntityId<'BenchBasic'>
  readonly type: 'BenchBasic'
}
export const BenchBasic: DomainEntityReflection<BenchBasic> = new DomainEntityReflection<BenchBasic>('BenchBasic', [])

export type AnyDomainEntity =
  | Table
  | RectangleTop
  | SquareTop
  | RoundTop
  | EllipticalOvalTop
  | RacetrackOvalTop
  | BoatShapeTop
  | AnchorBase
  | AnchorSingleFeetBase
  | AnchorSinglePlatformBase
  | BellhouseBase
  | BellhouseSingleFeetBase
  | BellhouseSinglePlatformBase
  | BellyStretchedBase
  | BrewerBase
  | BrewerSingleBase
  | CaseyBase
  | CraftsmanBase
  | CraftsmanSingleBase
  | CrescentBase
  | CrescentSingleBase
  | DanaBase
  | DanaSingleBase
  | FranklinBase
  | FranklinSingleFeetBase
  | FranklinSinglePlatformBase
  | MantisBase
  | MarksBase
  | MeredithBase
  | MeredithSingleFeetBase
  | MeredithSinglePlatformBase
  | OswaldBase
  | OswaldSingleBase
  | PeruStretchedBase
  | RishBase
  | RishSingleBase
  | RogersBase
  | RogersSinglePlatformBase
  | TamaraBase
  | TamaraSingleBase
  | TuscanBase
  | TuscanSingleFeetBase
  | TuscanSinglePlatformBase
  | WaldenBase
  | WaldenSingleBase
  | AnglePictureFrameBase
  | XBase
  | XSingleBase
  | AnglePictureFrameSingleBase
  | AnglePictureFrameCTCBase
  | ArchBase
  | ArchSingleBase
  | BoxFrameBase
  | ConnectedXBase
  | SlimConnectedXBase
  | SlimConnectedXSingleBase
  | ReflectionBase
  | ReflectionCTCBase
  | SinglePostBase
  | SinglePostSingleBase
  | XMetalBase
  | XMetalSingleBase
  | IvyBase
  | DremorTurnedBase
  | HerricksonTurnedBase
  | MidModernTaperBase
  | NarrowEnglishTurnedBase
  | OldEnglishTurnedBase
  | SlagleTurnedBase
  | TraditionalBase
  | TraditionalFlushBase
  | ReededBase
  | HershBase
  | TriflectionBase
  | ApronBasic
  | ApronNone
  | BenchBasic
export const AnyDomainEntity: RawAliasReflection<AnyDomainEntity> = new RawAliasReflection<AnyDomainEntity>(
  'AnyDomainEntity',
  [
    Table,
    RectangleTop,
    SquareTop,
    RoundTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop,
    AnchorBase,
    AnchorSingleFeetBase,
    AnchorSinglePlatformBase,
    BellhouseBase,
    BellhouseSingleFeetBase,
    BellhouseSinglePlatformBase,
    BellyStretchedBase,
    BrewerBase,
    BrewerSingleBase,
    CaseyBase,
    CraftsmanBase,
    CraftsmanSingleBase,
    CrescentBase,
    CrescentSingleBase,
    DanaBase,
    DanaSingleBase,
    FranklinBase,
    FranklinSingleFeetBase,
    FranklinSinglePlatformBase,
    MantisBase,
    MarksBase,
    MeredithBase,
    MeredithSingleFeetBase,
    MeredithSinglePlatformBase,
    OswaldBase,
    OswaldSingleBase,
    PeruStretchedBase,
    RishBase,
    RishSingleBase,
    RogersBase,
    RogersSinglePlatformBase,
    TamaraBase,
    TamaraSingleBase,
    TuscanBase,
    TuscanSingleFeetBase,
    TuscanSinglePlatformBase,
    WaldenBase,
    WaldenSingleBase,
    AnglePictureFrameBase,
    XBase,
    XSingleBase,
    AnglePictureFrameSingleBase,
    AnglePictureFrameCTCBase,
    ArchBase,
    ArchSingleBase,
    BoxFrameBase,
    ConnectedXBase,
    SlimConnectedXBase,
    SlimConnectedXSingleBase,
    ReflectionBase,
    ReflectionCTCBase,
    SinglePostBase,
    SinglePostSingleBase,
    XMetalBase,
    XMetalSingleBase,
    IvyBase,
    DremorTurnedBase,
    HerricksonTurnedBase,
    MidModernTaperBase,
    NarrowEnglishTurnedBase,
    OldEnglishTurnedBase,
    SlagleTurnedBase,
    TraditionalBase,
    TraditionalFlushBase,
    ReededBase,
    HershBase,
    TriflectionBase,
    ApronBasic,
    ApronNone,
    BenchBasic,
  ]
)

export type RootEntity = Table
export const RootEntity: RawAliasReflection<RootEntity> = new RawAliasReflection<RootEntity>('RootEntity', [Table])

export type Top = RectangleTop | SquareTop | RoundTop | EllipticalOvalTop | RacetrackOvalTop | BoatShapeTop
export const Top: RawAliasReflection<Top> = new RawAliasReflection<Top>('Top', [
  RectangleTop,
  SquareTop,
  RoundTop,
  EllipticalOvalTop,
  RacetrackOvalTop,
  BoatShapeTop,
])

export type Base =
  | AnchorBase
  | AnchorSingleFeetBase
  | AnchorSinglePlatformBase
  | BellhouseBase
  | BellhouseSingleFeetBase
  | BellhouseSinglePlatformBase
  | BellyStretchedBase
  | BrewerBase
  | BrewerSingleBase
  | CaseyBase
  | CraftsmanBase
  | CraftsmanSingleBase
  | CrescentBase
  | CrescentSingleBase
  | DanaBase
  | DanaSingleBase
  | FranklinBase
  | FranklinSingleFeetBase
  | FranklinSinglePlatformBase
  | MantisBase
  | MarksBase
  | MeredithBase
  | MeredithSingleFeetBase
  | MeredithSinglePlatformBase
  | OswaldBase
  | OswaldSingleBase
  | PeruStretchedBase
  | RishBase
  | RishSingleBase
  | RogersBase
  | RogersSinglePlatformBase
  | TamaraBase
  | TamaraSingleBase
  | TuscanBase
  | TuscanSingleFeetBase
  | TuscanSinglePlatformBase
  | WaldenBase
  | WaldenSingleBase
  | XBase
  | XSingleBase
  | AnglePictureFrameBase
  | AnglePictureFrameSingleBase
  | AnglePictureFrameCTCBase
  | ArchBase
  | ArchSingleBase
  | BoxFrameBase
  | ConnectedXBase
  | SlimConnectedXBase
  | SlimConnectedXSingleBase
  | ReflectionBase
  | ReflectionCTCBase
  | SinglePostBase
  | SinglePostSingleBase
  | XMetalBase
  | XMetalSingleBase
  | IvyBase
  | DremorTurnedBase
  | HerricksonTurnedBase
  | MidModernTaperBase
  | NarrowEnglishTurnedBase
  | OldEnglishTurnedBase
  | SlagleTurnedBase
  | TraditionalBase
  | TraditionalFlushBase
  | ReededBase
  | HershBase
  | TriflectionBase
export const Base: RawAliasReflection<Base> = new RawAliasReflection<Base>('Base', [
  AnchorBase,
  AnchorSingleFeetBase,
  AnchorSinglePlatformBase,
  BellhouseBase,
  BellhouseSingleFeetBase,
  BellhouseSinglePlatformBase,
  BellyStretchedBase,
  BrewerBase,
  BrewerSingleBase,
  CaseyBase,
  CraftsmanBase,
  CraftsmanSingleBase,
  CrescentBase,
  CrescentSingleBase,
  DanaBase,
  DanaSingleBase,
  FranklinBase,
  FranklinSingleFeetBase,
  FranklinSinglePlatformBase,
  MantisBase,
  MarksBase,
  MeredithBase,
  MeredithSingleFeetBase,
  MeredithSinglePlatformBase,
  OswaldBase,
  OswaldSingleBase,
  PeruStretchedBase,
  RishBase,
  RishSingleBase,
  RogersBase,
  RogersSinglePlatformBase,
  TamaraBase,
  TamaraSingleBase,
  TuscanBase,
  TuscanSingleFeetBase,
  TuscanSinglePlatformBase,
  WaldenBase,
  WaldenSingleBase,
  XBase,
  XSingleBase,
  AnglePictureFrameBase,
  AnglePictureFrameSingleBase,
  AnglePictureFrameCTCBase,
  ArchBase,
  ArchSingleBase,
  BoxFrameBase,
  ConnectedXBase,
  SlimConnectedXBase,
  SlimConnectedXSingleBase,
  ReflectionBase,
  ReflectionCTCBase,
  SinglePostBase,
  SinglePostSingleBase,
  XMetalBase,
  XMetalSingleBase,
  IvyBase,
  DremorTurnedBase,
  HerricksonTurnedBase,
  MidModernTaperBase,
  NarrowEnglishTurnedBase,
  OldEnglishTurnedBase,
  SlagleTurnedBase,
  TraditionalBase,
  TraditionalFlushBase,
  ReededBase,
  HershBase,
  TriflectionBase,
])

export type Apron = ApronBasic | ApronNone
export const Apron: RawAliasReflection<Apron> = new RawAliasReflection<Apron>('Apron', [ApronBasic, ApronNone])

export type Bench = BenchBasic
export const Bench: RawAliasReflection<Bench> = new RawAliasReflection<Bench>('Bench', [BenchBasic])

export type TopOval = EllipticalOvalTop | RacetrackOvalTop
export const TopOval: RawAliasReflection<TopOval> = new RawAliasReflection<TopOval>('TopOval', [
  EllipticalOvalTop,
  RacetrackOvalTop,
])

export type TopWithSide = SquareTop
export const TopWithSide: RawAliasReflection<TopWithSide> = new RawAliasReflection<TopWithSide>('TopWithSide', [
  SquareTop,
])

export type TopWithWidthAndLength = RectangleTop | EllipticalOvalTop | RacetrackOvalTop | BoatShapeTop
export const TopWithWidthAndLength: RawAliasReflection<TopWithWidthAndLength> =
  new RawAliasReflection<TopWithWidthAndLength>('TopWithWidthAndLength', [
    RectangleTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop,
  ])

export type TopWithDiameter = RoundTop
export const TopWithDiameter: RawAliasReflection<TopWithDiameter> = new RawAliasReflection<TopWithDiameter>(
  'TopWithDiameter',
  [RoundTop]
)

export type TopWithRolledThickness = RectangleTop | SquareTop
export const TopWithRolledThickness: RawAliasReflection<TopWithRolledThickness> =
  new RawAliasReflection<TopWithRolledThickness>('TopWithRolledThickness', [RectangleTop, SquareTop])

export type BasePedestal =
  | AnchorBase
  | AnchorSingleFeetBase
  | AnchorSinglePlatformBase
  | BellhouseBase
  | BellhouseSingleFeetBase
  | BellhouseSinglePlatformBase
  | BellyStretchedBase
  | BrewerBase
  | BrewerSingleBase
  | CaseyBase
  | CraftsmanBase
  | CraftsmanSingleBase
  | CrescentBase
  | CrescentSingleBase
  | DanaBase
  | DanaSingleBase
  | FranklinBase
  | FranklinSingleFeetBase
  | FranklinSinglePlatformBase
  | MarksBase
  | MeredithBase
  | MeredithSingleFeetBase
  | MeredithSinglePlatformBase
  | OswaldBase
  | OswaldSingleBase
  | PeruStretchedBase
  | RishBase
  | RishSingleBase
  | RogersBase
  | RogersSinglePlatformBase
  | TamaraBase
  | TamaraSingleBase
  | TuscanBase
  | TuscanSingleFeetBase
  | TuscanSinglePlatformBase
  | WaldenBase
  | WaldenSingleBase
  | XBase
  | XSingleBase
  | ReededBase
  | HershBase
export const BasePedestal: RawAliasReflection<BasePedestal> = new RawAliasReflection<BasePedestal>('BasePedestal', [
  AnchorBase,
  AnchorSingleFeetBase,
  AnchorSinglePlatformBase,
  BellhouseBase,
  BellhouseSingleFeetBase,
  BellhouseSinglePlatformBase,
  BellyStretchedBase,
  BrewerBase,
  BrewerSingleBase,
  CaseyBase,
  CraftsmanBase,
  CraftsmanSingleBase,
  CrescentBase,
  CrescentSingleBase,
  DanaBase,
  DanaSingleBase,
  FranklinBase,
  FranklinSingleFeetBase,
  FranklinSinglePlatformBase,
  MarksBase,
  MeredithBase,
  MeredithSingleFeetBase,
  MeredithSinglePlatformBase,
  OswaldBase,
  OswaldSingleBase,
  PeruStretchedBase,
  RishBase,
  RishSingleBase,
  RogersBase,
  RogersSinglePlatformBase,
  TamaraBase,
  TamaraSingleBase,
  TuscanBase,
  TuscanSingleFeetBase,
  TuscanSinglePlatformBase,
  WaldenBase,
  WaldenSingleBase,
  XBase,
  XSingleBase,
  ReededBase,
  HershBase,
])

export type BaseMetal =
  | MantisBase
  | AnglePictureFrameBase
  | AnglePictureFrameSingleBase
  | AnglePictureFrameCTCBase
  | ArchBase
  | ArchSingleBase
  | BoxFrameBase
  | ConnectedXBase
  | SlimConnectedXBase
  | SlimConnectedXSingleBase
  | ReflectionBase
  | ReflectionCTCBase
  | SinglePostBase
  | SinglePostSingleBase
  | XMetalBase
  | XMetalSingleBase
  | TriflectionBase
export const BaseMetal: RawAliasReflection<BaseMetal> = new RawAliasReflection<BaseMetal>('BaseMetal', [
  MantisBase,
  AnglePictureFrameBase,
  AnglePictureFrameSingleBase,
  AnglePictureFrameCTCBase,
  ArchBase,
  ArchSingleBase,
  BoxFrameBase,
  ConnectedXBase,
  SlimConnectedXBase,
  SlimConnectedXSingleBase,
  ReflectionBase,
  ReflectionCTCBase,
  SinglePostBase,
  SinglePostSingleBase,
  XMetalBase,
  XMetalSingleBase,
  TriflectionBase,
])

export type BaseFourLeg =
  | IvyBase
  | DremorTurnedBase
  | HerricksonTurnedBase
  | MidModernTaperBase
  | NarrowEnglishTurnedBase
  | OldEnglishTurnedBase
  | SlagleTurnedBase
  | TraditionalBase
  | TraditionalFlushBase
export const BaseFourLeg: RawAliasReflection<BaseFourLeg> = new RawAliasReflection<BaseFourLeg>('BaseFourLeg', [
  IvyBase,
  DremorTurnedBase,
  HerricksonTurnedBase,
  MidModernTaperBase,
  NarrowEnglishTurnedBase,
  OldEnglishTurnedBase,
  SlagleTurnedBase,
  TraditionalBase,
  TraditionalFlushBase,
])

export type BaseSingleLeg =
  | BellyStretchedBase
  | BrewerSingleBase
  | AnchorSingleFeetBase
  | AnchorSinglePlatformBase
  | BellhouseSingleFeetBase
  | BellhouseSinglePlatformBase
  | CraftsmanSingleBase
  | CrescentSingleBase
  | DanaSingleBase
  | FranklinSingleFeetBase
  | FranklinSinglePlatformBase
  | MantisBase
  | MarksBase
  | MeredithSingleFeetBase
  | MeredithSinglePlatformBase
  | OswaldSingleBase
  | PeruStretchedBase
  | RishSingleBase
  | RogersSinglePlatformBase
  | TamaraSingleBase
  | TuscanSingleFeetBase
  | TuscanSinglePlatformBase
  | WaldenSingleBase
  | XSingleBase
  | AnglePictureFrameSingleBase
  | AnglePictureFrameCTCBase
  | ArchSingleBase
  | SlimConnectedXSingleBase
  | ReflectionBase
  | ReflectionCTCBase
  | SinglePostSingleBase
  | XMetalSingleBase
  | ReededBase
export const BaseSingleLeg: RawAliasReflection<BaseSingleLeg> = new RawAliasReflection<BaseSingleLeg>('BaseSingleLeg', [
  BellyStretchedBase,
  BrewerSingleBase,
  AnchorSingleFeetBase,
  AnchorSinglePlatformBase,
  BellhouseSingleFeetBase,
  BellhouseSinglePlatformBase,
  CraftsmanSingleBase,
  CrescentSingleBase,
  DanaSingleBase,
  FranklinSingleFeetBase,
  FranklinSinglePlatformBase,
  MantisBase,
  MarksBase,
  MeredithSingleFeetBase,
  MeredithSinglePlatformBase,
  OswaldSingleBase,
  PeruStretchedBase,
  RishSingleBase,
  RogersSinglePlatformBase,
  TamaraSingleBase,
  TuscanSingleFeetBase,
  TuscanSinglePlatformBase,
  WaldenSingleBase,
  XSingleBase,
  AnglePictureFrameSingleBase,
  AnglePictureFrameCTCBase,
  ArchSingleBase,
  SlimConnectedXSingleBase,
  ReflectionBase,
  ReflectionCTCBase,
  SinglePostSingleBase,
  XMetalSingleBase,
  ReededBase,
])

export type BaseDoubleLeg =
  | AnchorBase
  | BellhouseBase
  | BrewerBase
  | CaseyBase
  | CraftsmanBase
  | CrescentBase
  | DanaBase
  | FranklinBase
  | MeredithBase
  | OswaldBase
  | RishBase
  | RogersBase
  | TamaraBase
  | TuscanBase
  | WaldenBase
  | XBase
  | AnglePictureFrameBase
  | ArchBase
  | BoxFrameBase
  | ConnectedXBase
  | SlimConnectedXBase
  | SinglePostBase
  | XMetalBase
  | HershBase
  | TriflectionBase
export const BaseDoubleLeg: RawAliasReflection<BaseDoubleLeg> = new RawAliasReflection<BaseDoubleLeg>('BaseDoubleLeg', [
  AnchorBase,
  BellhouseBase,
  BrewerBase,
  CaseyBase,
  CraftsmanBase,
  CrescentBase,
  DanaBase,
  FranklinBase,
  MeredithBase,
  OswaldBase,
  RishBase,
  RogersBase,
  TamaraBase,
  TuscanBase,
  WaldenBase,
  XBase,
  AnglePictureFrameBase,
  ArchBase,
  BoxFrameBase,
  ConnectedXBase,
  SlimConnectedXBase,
  SinglePostBase,
  XMetalBase,
  HershBase,
  TriflectionBase,
])

export type BaseWithPlatform =
  | AnchorSinglePlatformBase
  | BellhouseSinglePlatformBase
  | BellyStretchedBase
  | FranklinSinglePlatformBase
  | MeredithSinglePlatformBase
  | TuscanSinglePlatformBase
  | PeruStretchedBase
  | RogersSinglePlatformBase
export const BaseWithPlatform: RawAliasReflection<BaseWithPlatform> = new RawAliasReflection<BaseWithPlatform>(
  'BaseWithPlatform',
  [
    AnchorSinglePlatformBase,
    BellhouseSinglePlatformBase,
    BellyStretchedBase,
    FranklinSinglePlatformBase,
    MeredithSinglePlatformBase,
    TuscanSinglePlatformBase,
    PeruStretchedBase,
    RogersSinglePlatformBase,
  ]
)

export type BaseFourLegCombined = IvyBase
export const BaseFourLegCombined: RawAliasReflection<BaseFourLegCombined> = new RawAliasReflection<BaseFourLegCombined>(
  'BaseFourLegCombined',
  [IvyBase]
)

export type BaseFourLegSeparate =
  | DremorTurnedBase
  | HerricksonTurnedBase
  | MidModernTaperBase
  | NarrowEnglishTurnedBase
  | OldEnglishTurnedBase
  | SlagleTurnedBase
  | TraditionalBase
  | TraditionalFlushBase
export const BaseFourLegSeparate: RawAliasReflection<BaseFourLegSeparate> = new RawAliasReflection<BaseFourLegSeparate>(
  'BaseFourLegSeparate',
  [
    DremorTurnedBase,
    HerricksonTurnedBase,
    MidModernTaperBase,
    NarrowEnglishTurnedBase,
    OldEnglishTurnedBase,
    SlagleTurnedBase,
    TraditionalBase,
    TraditionalFlushBase,
  ]
)

export type TopWithSquareCorners = RectangleTop | SquareTop
export const TopWithSquareCorners: RawAliasReflection<TopWithSquareCorners> =
  new RawAliasReflection<TopWithSquareCorners>('TopWithSquareCorners', [RectangleTop, SquareTop])

export type TopWithRoundedCorners = RoundTop | EllipticalOvalTop | RacetrackOvalTop | BoatShapeTop
export const TopWithRoundedCorners: RawAliasReflection<TopWithRoundedCorners> =
  new RawAliasReflection<TopWithRoundedCorners>('TopWithRoundedCorners', [
    RoundTop,
    EllipticalOvalTop,
    RacetrackOvalTop,
    BoatShapeTop,
  ])

export type StretchedBase = BellyStretchedBase | PeruStretchedBase
export const StretchedBase: RawAliasReflection<StretchedBase> = new RawAliasReflection<StretchedBase>('StretchedBase', [
  BellyStretchedBase,
  PeruStretchedBase,
])

export const aliases = {
  AnyDomainEntity: AnyDomainEntity.types,
  RootEntity: RootEntity.types,
  Top: Top.types,
  Base: Base.types,
  Apron: Apron.types,
  Bench: Bench.types,
  TopOval: TopOval.types,
  TopWithSide: TopWithSide.types,
  TopWithWidthAndLength: TopWithWidthAndLength.types,
  TopWithDiameter: TopWithDiameter.types,
  TopWithRolledThickness: TopWithRolledThickness.types,
  BasePedestal: BasePedestal.types,
  BaseMetal: BaseMetal.types,
  BaseFourLeg: BaseFourLeg.types,
  BaseSingleLeg: BaseSingleLeg.types,
  BaseDoubleLeg: BaseDoubleLeg.types,
  BaseWithPlatform: BaseWithPlatform.types,
  BaseFourLegCombined: BaseFourLegCombined.types,
  BaseFourLegSeparate: BaseFourLegSeparate.types,
  TopWithSquareCorners: TopWithSquareCorners.types,
  TopWithRoundedCorners: TopWithRoundedCorners.types,
  StretchedBase: StretchedBase.types,
} as const
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type Aliases = {
  AnyDomainEntity: AnyDomainEntity
  RootEntity: RootEntity
  Top: Top
  Base: Base
  Apron: Apron
  Bench: Bench
  TopOval: TopOval
  TopWithSide: TopWithSide
  TopWithWidthAndLength: TopWithWidthAndLength
  TopWithDiameter: TopWithDiameter
  TopWithRolledThickness: TopWithRolledThickness
  BasePedestal: BasePedestal
  BaseMetal: BaseMetal
  BaseFourLeg: BaseFourLeg
  BaseSingleLeg: BaseSingleLeg
  BaseDoubleLeg: BaseDoubleLeg
  BaseWithPlatform: BaseWithPlatform
  BaseFourLegCombined: BaseFourLegCombined
  BaseFourLegSeparate: BaseFourLegSeparate
  TopWithSquareCorners: TopWithSquareCorners
  TopWithRoundedCorners: TopWithRoundedCorners
  StretchedBase: StretchedBase
}

export const entities: EntityReflections<AnyDomainEntity> = {
  Table,
  RectangleTop,
  SquareTop,
  RoundTop,
  EllipticalOvalTop,
  RacetrackOvalTop,
  BoatShapeTop,
  AnchorBase,
  AnchorSingleFeetBase,
  AnchorSinglePlatformBase,
  BellhouseBase,
  BellhouseSingleFeetBase,
  BellhouseSinglePlatformBase,
  BellyStretchedBase,
  BrewerBase,
  BrewerSingleBase,
  CaseyBase,
  CraftsmanBase,
  CraftsmanSingleBase,
  CrescentBase,
  CrescentSingleBase,
  DanaBase,
  DanaSingleBase,
  FranklinBase,
  FranklinSingleFeetBase,
  FranklinSinglePlatformBase,
  MantisBase,
  MarksBase,
  MeredithBase,
  MeredithSingleFeetBase,
  MeredithSinglePlatformBase,
  OswaldBase,
  OswaldSingleBase,
  PeruStretchedBase,
  RishBase,
  RishSingleBase,
  RogersBase,
  RogersSinglePlatformBase,
  TamaraBase,
  TamaraSingleBase,
  TuscanBase,
  TuscanSingleFeetBase,
  TuscanSinglePlatformBase,
  WaldenBase,
  WaldenSingleBase,
  AnglePictureFrameBase,
  XBase,
  XSingleBase,
  AnglePictureFrameSingleBase,
  AnglePictureFrameCTCBase,
  ArchBase,
  ArchSingleBase,
  BoxFrameBase,
  ConnectedXBase,
  SlimConnectedXBase,
  SlimConnectedXSingleBase,
  ReflectionBase,
  ReflectionCTCBase,
  SinglePostBase,
  SinglePostSingleBase,
  XMetalBase,
  XMetalSingleBase,
  IvyBase,
  DremorTurnedBase,
  HerricksonTurnedBase,
  MidModernTaperBase,
  NarrowEnglishTurnedBase,
  OldEnglishTurnedBase,
  SlagleTurnedBase,
  TraditionalBase,
  TraditionalFlushBase,
  ReededBase,
  HershBase,
  TriflectionBase,
  ApronBasic,
  ApronNone,
  BenchBasic,
} as const

declare global {
  interface Model {
    readonly Table: Table
    readonly RectangleTop: RectangleTop
    readonly SquareTop: SquareTop
    readonly RoundTop: RoundTop
    readonly EllipticalOvalTop: EllipticalOvalTop
    readonly RacetrackOvalTop: RacetrackOvalTop
    readonly BoatShapeTop: BoatShapeTop
    readonly AnchorBase: AnchorBase
    readonly AnchorSingleFeetBase: AnchorSingleFeetBase
    readonly AnchorSinglePlatformBase: AnchorSinglePlatformBase
    readonly BellhouseBase: BellhouseBase
    readonly BellhouseSingleFeetBase: BellhouseSingleFeetBase
    readonly BellhouseSinglePlatformBase: BellhouseSinglePlatformBase
    readonly BellyStretchedBase: BellyStretchedBase
    readonly BrewerBase: BrewerBase
    readonly BrewerSingleBase: BrewerSingleBase
    readonly CaseyBase: CaseyBase
    readonly CraftsmanBase: CraftsmanBase
    readonly CraftsmanSingleBase: CraftsmanSingleBase
    readonly CrescentBase: CrescentBase
    readonly CrescentSingleBase: CrescentSingleBase
    readonly DanaBase: DanaBase
    readonly DanaSingleBase: DanaSingleBase
    readonly FranklinBase: FranklinBase
    readonly FranklinSingleFeetBase: FranklinSingleFeetBase
    readonly FranklinSinglePlatformBase: FranklinSinglePlatformBase
    readonly MantisBase: MantisBase
    readonly MarksBase: MarksBase
    readonly MeredithBase: MeredithBase
    readonly MeredithSingleFeetBase: MeredithSingleFeetBase
    readonly MeredithSinglePlatformBase: MeredithSinglePlatformBase
    readonly OswaldBase: OswaldBase
    readonly OswaldSingleBase: OswaldSingleBase
    readonly PeruStretchedBase: PeruStretchedBase
    readonly RishBase: RishBase
    readonly RishSingleBase: RishSingleBase
    readonly RogersBase: RogersBase
    readonly RogersSinglePlatformBase: RogersSinglePlatformBase
    readonly TamaraBase: TamaraBase
    readonly TamaraSingleBase: TamaraSingleBase
    readonly TuscanBase: TuscanBase
    readonly TuscanSingleFeetBase: TuscanSingleFeetBase
    readonly TuscanSinglePlatformBase: TuscanSinglePlatformBase
    readonly WaldenBase: WaldenBase
    readonly WaldenSingleBase: WaldenSingleBase
    readonly AnglePictureFrameBase: AnglePictureFrameBase
    readonly XBase: XBase
    readonly XSingleBase: XSingleBase
    readonly AnglePictureFrameSingleBase: AnglePictureFrameSingleBase
    readonly AnglePictureFrameCTCBase: AnglePictureFrameCTCBase
    readonly ArchBase: ArchBase
    readonly ArchSingleBase: ArchSingleBase
    readonly BoxFrameBase: BoxFrameBase
    readonly ConnectedXBase: ConnectedXBase
    readonly SlimConnectedXBase: SlimConnectedXBase
    readonly SlimConnectedXSingleBase: SlimConnectedXSingleBase
    readonly ReflectionBase: ReflectionBase
    readonly ReflectionCTCBase: ReflectionCTCBase
    readonly SinglePostBase: SinglePostBase
    readonly SinglePostSingleBase: SinglePostSingleBase
    readonly XMetalBase: XMetalBase
    readonly XMetalSingleBase: XMetalSingleBase
    readonly IvyBase: IvyBase
    readonly DremorTurnedBase: DremorTurnedBase
    readonly HerricksonTurnedBase: HerricksonTurnedBase
    readonly MidModernTaperBase: MidModernTaperBase
    readonly NarrowEnglishTurnedBase: NarrowEnglishTurnedBase
    readonly OldEnglishTurnedBase: OldEnglishTurnedBase
    readonly SlagleTurnedBase: SlagleTurnedBase
    readonly TraditionalBase: TraditionalBase
    readonly TraditionalFlushBase: TraditionalFlushBase
    readonly ReededBase: ReededBase
    readonly HershBase: HershBase
    readonly TriflectionBase: TriflectionBase
    readonly ApronBasic: ApronBasic
    readonly ApronNone: ApronNone
    readonly BenchBasic: BenchBasic

    readonly ThicknessesTypes: ThicknessesTypes
    readonly BaseTypes: BaseTypes
    readonly WoodSpecies: WoodSpecies
    readonly DistressLevels: DistressLevels
    readonly EdgeStyles: EdgeStyles
    readonly Finishes: Finishes
    readonly SheenTypes: SheenTypes
    readonly LeafTypes: LeafTypes
    readonly SeatingTypes: SeatingTypes
    readonly CrossbraceTypes: CrossbraceTypes

    readonly AnyDomainEntity: AnyDomainEntity
    readonly RootEntity: RootEntity
    readonly Top: Top
    readonly Base: Base
    readonly Apron: Apron
    readonly Bench: Bench
    readonly TopOval: TopOval
    readonly TopWithSide: TopWithSide
    readonly TopWithWidthAndLength: TopWithWidthAndLength
    readonly TopWithDiameter: TopWithDiameter
    readonly TopWithRolledThickness: TopWithRolledThickness
    readonly BasePedestal: BasePedestal
    readonly BaseMetal: BaseMetal
    readonly BaseFourLeg: BaseFourLeg
    readonly BaseSingleLeg: BaseSingleLeg
    readonly BaseDoubleLeg: BaseDoubleLeg
    readonly BaseWithPlatform: BaseWithPlatform
    readonly BaseFourLegCombined: BaseFourLegCombined
    readonly BaseFourLegSeparate: BaseFourLegSeparate
    readonly TopWithSquareCorners: TopWithSquareCorners
    readonly TopWithRoundedCorners: TopWithRoundedCorners
    readonly StretchedBase: StretchedBase
  }
}
